import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

export default function SmoothScroll() {
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const targetY = () => el.getBoundingClientRect().top + window.scrollY - 20;
  if (window.__lenis) {
    window.__lenis.scrollTo(targetY());
    // self-correct once below-the-fold layout (images/reveals) settles
    setTimeout(() => {
      const t = targetY();
      if (Math.abs(t - window.scrollY) > 40) window.__lenis.scrollTo(t, { duration: 0.6 });
    }, 1300);
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
